import { TYPES } from "../../ProseMirrorNode.constants";

// The Read page strips out some elements containing only hard breaks.
const getHasOnlyHardBreakChildren = (node) =>
  !node?.content?.find((childNode) => childNode.type !== TYPES.hardBreak);

export default getHasOnlyHardBreakChildren;
